import { cx } from "class-variance-authority";
import type { PropsWithChildren } from "react";
import {
  OverlayArrow as AriaOverlayArrow,
  Tooltip as AriaTooltip,
  type TooltipProps as AriaTooltipProps,
  TooltipTrigger as AriaTooltipTrigger,
} from "react-aria-components";

import { PointerHorizontalIcon } from "@/assets/icons/ui/PointerHorizontal";
import { PointerVerticalIcon } from "@/assets/icons/ui/PointerVertical";
import { Typography } from "@/components/ui/text/Typography/Typography";

type TooltipProps = PropsWithChildren &
  AriaTooltipProps & {
    text?: string;
    tooltipContent?: React.ReactNode;
    className?: string;
    pointerClassName?: string;
    delay?: number;
  };

export const Tooltip = ({
  children,
  text,
  tooltipContent,
  className,
  pointerClassName,
  delay = 0,
  ...tooltipProps
}: TooltipProps) => {
  return (
    <AriaTooltipTrigger
      delay={delay}
      closeDelay={0}
      isDisabled={!text && !tooltipContent}
    >
      {children}
      <AriaTooltip
        className={cx("group max-w-64 rounded-sm bg-interactive-secondary-idle px-3 py-2 shadow-2", className)}
        offset={15}
        {...tooltipProps}
      >
        <AriaOverlayArrow>
          <PointerHorizontalIcon
            className={cx(
              "h-2-5 w-5 text-elevation-outline-1 group-placement-left:hidden group-placement-right:hidden group-placement-top:rotate-180",
              pointerClassName,
            )}
          />
          <PointerVerticalIcon
            className={cx(
              "h-5 w-2-5 text-elevation-outline-1 group-placement-bottom:hidden group-placement-top:hidden group-placement-left:rotate-180",
              pointerClassName,
            )}
          />
        </AriaOverlayArrow>
        <Typography
          size="label-4"
          className="text-text-inverted-tertiary"
        >
          {text}
        </Typography>
        {tooltipContent}
      </AriaTooltip>
    </AriaTooltipTrigger>
  );
};
